
<template>
  <v-dialog
    v-model="dialog"
    max-width="750"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Company
            </h4>
            <p class="category font-weight-thin">
              Edit Company
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col class="subtitle-1">
              Company: {{ editedCompany.name }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-radio-group
                v-model="editedCompany.is_excluded"
                v-validate="'required'"
                :error-messages="errors.collect('editedCompany.is_excluded')"
                data-vv-name="editedCompany.is_excluded"
                data-vv-as="is_excluded"
                row
              >
                <template v-slot:label>
                  <div>MSC Status</div>
                </template>
                <v-radio
                  label="Yes"
                  :value="0"
                />
                <v-radio
                  label="No"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="5"
              style="padding-top: 20px"
            >
              <div>Current Company's Tax Settings:</div>
            </v-col>
            <v-col>
              <v-btn
                class="mx-2"
                tile
                dark
                medium
                color="success"
                @click="addCompanyTax"
              >
                <v-icon dark>
                  mdi-plus
                </v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-for="(tax, index) in editedCompany.company_tax"
            :key="index"
          >
            <v-col
              v-if="taxesForm[index].id === null"
              cols="1"
              class="pt-9"
            >
              <v-btn
                icon
                x-small
                color="red"
                @click="deleteTax(index)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="taxesForm[index].tax_setting_id"
                v-validate="'required'"
                :disabled="taxesForm[index].id !== null"
                item-text="name"
                item-value="id"
                :items="taxesForm[index].id ? taxes : filteredTaxes"
                label="Tax"
                :error-messages="errors.collect('tax'+index)"
                :name="'tax'+ index"
                data-vv-as="Tax"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="taxesForm[index].registration_no"
                v-validate="'required'"
                label="Tax Registration No."
                :error-messages="errors.collect('registration'+index)"
                :name="'registration'+ index"
                data-vv-as="registration no."
                @change="percentage = parseFloat(taxesForm[index].registration_no).toFixed(2)"
              />
            </v-col>
            <v-col>
              <v-switch
                v-model="taxesForm[index].is_active"
                :label="`${taxesForm[index].is_active ? 'Active Tax' : 'Inactive Tax'}`"
                :disabled="taxesForm[index].tax_setting ? !taxesForm[index].tax_setting.is_valid : false"
              />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      companyId: String,
    },
    data () {
      return {
        dialog: false,
        taxes: [],
        taxesForm: [],
        company: null,
        editedCompany: null,
        loading: false,
        progressing: false,
        currentNoOfTaxSetting: 0,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$validator.pause()
          this.$resetData()
        } else {
          this.loadData()
          this.$validator.resume()
        }
      },
    },
    methods: {
      addCompanyTax () {
        if (this.taxesForm.length < (this.filteredTaxes.length + this.currentNoOfTaxSetting)) {
          this.taxesForm.push({
            id: null,
            tax_setting_id: null,
            registration_no: null,
            is_active: 1,
          })
        } else {
          this.$snack({ color: 'error', message: 'There are no more tax settings to add' })
        }
      },
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.companies().show(this.companyId),
          this.$api.taxSettings().list(),
        ])
          .then(([companies, taxSettings]) => {
            this.company = companies.data
            this.editedCompany = { ...this.company }
            this.taxesForm = this.editedCompany.company_tax

            this.existedTaxId = this.editedCompany.company_tax.map(item => {
              // retrieve the ids of existed tax
              return item.tax_setting_id
            })
            
            this.currentNoOfTaxSetting = this.existedTaxId.length 
            this.taxes = taxSettings.data
            this.filteredTaxes = this.taxes.filter(item => {
              // filter out tax option for existed company tax and inactive tax selection
              return !this.existedTaxId.includes(item.id) && item.is_valid
            })
            this.loading = false
          })
      },
      deleteTax (index) {
        this.taxesForm.splice(index, 1)
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            this.$api.companies().update(this.companyId, this.prepareFormData())
              .then((response) => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ color: 'success', message: response.data.status })

                  this.dialog = false
                }
              }).catch((err) => {
                console.log(err)
                if (err.response.status === 422) {
                  const errors = err.response.data.errors
                  let errorMessage = ''
                  for (const key in errors) {
                    errorMessage += errors[key].toString() + '\n'
                  }
                  this.$snack({ color: 'error', message: errorMessage })
                } else {
                  this.$snack({ color: 'error', message: err.response.statusText })
                }
              }).then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        const tempArray = []
        
        this.taxesForm.map(tax => {
          tempArray.push({
            id: tax.id,
            tax_setting_id: tax.tax_setting_id,
            registration_no: tax.registration_no,
            is_active: tax.is_active,
          })
        })
        return {
          is_excluded: this.editedCompany.is_excluded,
          taxes: tempArray,
        }
      },
    },
  }
</script>
